import React, { useEffect, useState } from "react";
import "./Requetsuser.css";
import img from "../../../../../images/car.png";
import img2 from "../../../../../images/travel-and-tourism.png";
import img3 from "../../../../../images/traff.png";
import img4 from "../../../../../images/contract.png";
import img5 from "../../../../../images/inbox.png";
import img6 from "../../../../../images/hand.png";

import Pagination from "../../../../Pagination";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetAllApplicationAction, deleteApplicationAction } from "../../../../../redux/actions/ApplicationAction";
import notify from "../../../../../Notifcation";
import { Button, Modal } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
const Requetsuser = ({ userData }) => {
  const dispatch = useDispatch();
  const AllReq = useSelector((state) => state.ApplicationReduser.GetallApp);
  const [IDAPP, setIDAPP] = useState("");

  const [Deletesow, setDeletesow] = useState(false);
  const handleCloseDelete = () => setDeletesow(false);
  const handleShowDelete = (item) => {
    setDeletesow(true);
    setIDAPP(item);
  };
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  useEffect(() => {
    dispatch(GetAllApplicationAction());
  }, []);
  const onPress = async (page) => {
    await dispatch(GetAllApplicationAction(`page=${page}`));
  };
  const handleDelete = async () => {
    setisPress(true);
    await dispatch(
      deleteApplicationAction(`/api/delete-application-client/`, {
        application_id: IDAPP,
      })
    );
    setDeletesow(false);
    setLoading(false);
    setisPress(false);
    setIDAPP("");
  };

  const del = useSelector((state) => state.ApplicationReduser.deleteApp);
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (del) {
        if (del.status === 200 || del.status === 201) {
          if (del.data) {
            notify(del.data.message, "success");
            dispatch(GetAllApplicationAction());

          }
        } else if (del.status !== 200 || del.status !== 201) {
          if (del.data) {
            notify(del.data.message, "error");
            dispatch(GetAllApplicationAction());
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
            dispatch(GetAllApplicationAction());
          }
        }
      }
    }
  }, [loading]);

  return (
    <div className="bg-body-secondary dirr">
      <div className="text-end w-75 mx-auto p-3 d-flex flex-column justify-content-center align-items-center bg-body-secondary">
        {AllReq &&AllReq.results && AllReq.results.length >0? (
          AllReq.results.map((item, idx) => (
            <>
            <Link
              key={idx}
              className="w-100"
              to={`/user/requestsuserdetails/${item.application_id}`}
              style={{ textDecoration: "none" }}
            >
              <div
                className="card mb-2 rounded border-0"
                style={{ maxWidth: "inherit" }}
              >
                <div className="row d-flex flex-row-reverse g-0 ">
                  <div className="col-md-4 d-flex justify-content-center align-items-center">
                    {item.application_type === 1 ? (
                      <img src={img} className="img-fluid w-50" alt="..." />
                    ) : item.application_type === 2 ? (
                      <img src={img2} className="img-fluid w-50" alt="..." />
                    ) : item.application_type === 3 ? (
                      <img src={img2} className="img-fluid w-50" alt="..." />
                    ) : item.application_type === 4 ? (
                      <img src={img2} className="img-fluid w-50" alt="..." />
                    ) : item.application_type === 5 ? (
                      <img src={img3} className="img-fluid w-50" alt="..." />
                    ) : item.application_type === 6? (
                      <img src={img4} className="img-fluid w-50" alt="..." />
                    ) : item.application_type === 7 ?(
                      <img src={img5} className="img-fluid w-50" alt="..." />
                    ):
                    item.application_type === 8 ?(
                      <img src={img6} className="img-fluid w-50" alt="..." />
                    ):
                    
                    (
                      ""
                    )}
                  </div>
                  <div className="col-md-8">
                    <div className="card-body">
                      <div className="head-info d-flex flex-row-reverse justify-content-between">
                        <h5 className="card-title">
                          {item.application_type === 1
                            ? "طلب سيارة"
                            : item.application_type === 2
                            ? "حجز تذكرة طيران "
                            : item.application_type === 3
                            ? "فيزا "
                            : item.application_type === 4
                            ? "اقامة"
                            : item.application_type === 5
                            ? "خدمات المرور"
                            : item.application_type === 6
                            ? "خدمات الشهر العقاري"
                            : item.application_type === 7
                            ? "خدمات المحليات "
                            : item.application_type === 8
                            ? "خدمات تخليص المعاملات "
                            : ""}
                        </h5>
                        <h7 className="card-title">
                          حالة الطلب{" "}
                          {item.status === 1
                            ? "(تم الأنشاء )"
                            : item.status === 2
                            ? "(تحت المراجعة)"
                            : item.status === 3
                            ? "(تمت الأرشفة)"
                            : item.status === 4
                            ? "(تمت الموافقة)"
                            : item.status === 5
                            ? "(تم رفض الطلب)"
                            : item.status === 6
                            ? "(تم الأنتهاء )"
                            : null}
                        </h7>
                      </div>
                      <p className="card-text">
                       الأسم : {item.client_username}
                      </p>
                      <p className="card-text">
                        رقم الهاتف : {item.client_mobile}
                      </p>
                      <p className="card-text">
                        الرقم القومي : {item.client_national_id}
                      </p>
                      <p className="card-text">
                        رقم الطلب : #{item.application_id}
                      </p>
                      <div className="d-flex flex-row justify-content-between">
                        <p className="card-text">
                          <small className="text-body-secondary">
                            {new Date(item.modification_date).toLocaleString(
                              "en-US"
                            )}
                            اخر تحديث منذ
                          </small>
                        </p>
                        {userData && userData.user_type === "admin" ? (
                          <Link
                            to="/admin/requestsuserdetails/:id"
                            className="text-decoration-none"
                          >
                            تفاصيل الطلب
                          </Link>
                        ) : (
                          <Link
                            to={`/user/requestsuserdetails/${item.application_id}`}
                            className="text-decoration-none"
                          >
                            تفاصيل الطلب
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
            <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() =>
                  handleShowDelete(item.application_id)
                }
              >
                هل تريد حذف الطلب <i className="fa-solid fa-trash-can"></i>
              </div>
            </>
          ))
        ) : (
          <h4>لاتوجد طلبات</h4>
        )}
                <Pagination
          pageCount={AllReq && AllReq.total_pages}
          onPress={onPress}
        />
      </div>
      <ToastContainer />
      <Modal
        show={Deletesow}
        onHide={handleCloseDelete}
        backdrop="static"
        centered
        keyboard={false}
        contentClassName="cont"
        style={{ width: "100%", margin: "0px auto", textAlign: "center" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>هل تريد حذف الطلب</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <h3 style={{ color: "red" }}>
            في حالة حذف الطلب سيتم تطبيق شروط العقد
          </h3>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseDelete}
          >
            إغلاق
          </Button>
          <Button variant="secondary" className="close" onClick={handleDelete}>
            موافق
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Requetsuser;
